import SideBar from "./components/Sidebar/SideBar";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "./components/hrNavbar.js";
import Signin from "./Common/Signin.jsx";
import Dashboard from "./pages/Dashboard/Dashboard.jsx";
import Handbook from "./pages/HandBook/handbook.jsx";
import EmpAnnouncments from "./pages/Announcments/Emp-Announcments.jsx";
import DeptAnnouncements from "./pages/DeptAnnouncements/DeptAnnouncements.jsx";
import Rules from "./pages/Rules/rules.jsx";
import PublicHolidays from "./pages/PublicHoliday/PublicHolidays.jsx";
import AddHoliday from "./pages/PublicHoliday/add-holiday.js";
import EditHoliday from "./pages/PublicHoliday/Edit-PublicHoliday.jsx";
import EmployeeInformation from "./pages/AddEmp/emp-info.js";
import AddEmp from "./pages/AddEmp/add-emp.js";
import AddHR from "./pages/AddHR/add-hr.js";
import HrInformation from "./pages/AddHR/hr-info.js";
import EmpTiming from "./pages/EmpSchedule/emp-timing.js";
import EmpsSchedule from "./pages/EmpSchedule/emps-schedule.js";
import EditTiming from "./pages/EmpSchedule/edit-timing.js";
import HrSchedule from "./pages/HRSchedule/hr-schedule.js";
import HrTiming from "./pages/HRSchedule/hr-timing.js";
import HrShift from "./pages/HRSchedule/hr-shift.js";
import TotalLeave from "./pages/Leave/total-leave.js";
import PendingLeave from "./pages/Leave/pending-leave.js";
import ApprovedLeave from "./pages/Leave/approved-leave.js";
import RejectedLeave from "./pages/Leave/rejected-leave.js";
import LeaveReport from "./pages/Leave/LeaveReport/leave-report.js";
import EmpsLeaveReports from "./pages/Leave/LeaveReport/emps-leave-reports.js";
import Leave from "./pages/Leave/leave.js";
import Performance from "./pages/EmpsPerformance/emps-performance.js";
import EditAtd from "./pages/EmpAtd/edit-atd.js";
import AddAtd from "./pages/EmpAtd/add-atd.js";
import Reports from "./pages/EmpsPerformance/reports.js";
import CurrentAtd from "./pages/EmpAtd/current-atd.js";
import YesterdayAttendance from "./pages/EmpAtd/yesterday-atd.js";
import ViewAtd from "./pages/EmpAtd/view-atd.js";
import AllEmps from "./pages/EmpAtd/all-emps.js";
import AddAbsent from "./pages/EmpAtd/add-absent.js";
import TodayReport from "./pages/EmpWorkReport/today-reports.js";
import MonthReport from "./pages/EmpWorkReport/current-month-report.js";
import EmpsWorkReports from "./pages/EmpWorkReport/all-work-reports.js";
import Profile from "./pages/Profile/my-profile.js";
import MySchedule from "./pages/Schedule/my-schedule.js";
import Salary from "./pages/MySalary/my-salary.js";
import OverTimeReport from "./pages/OverTime/my-overtime-report.js";
import WorkReports from "./pages/MyWorkReport/my-work-reports.js";
import Settings from "./pages/AccountSetting/account-settings.js";
import ResetPassword from "./pages/AccountSetting/reset-password.js";
import AddReport from "./pages/MyWorkReport/add-report.js";
import ProvidentFund from "./pages/PFund/provident-fund.js";
import ProvidentFundHistory from "./pages/PFund/provident-fund-history.js";
import ProvidentFundReq from "./pages/PFund/provident-fund-req.js";
import TimeHistory from "./pages/TimingHistory/time-history.js";
import TimingsHistory from "./pages/TimingHistory/timings-history.js";
import EmployeeHierarchy from "./pages/Teamchart.js";
import MyPayroll from "./pages/MyPayroll/my-payroll.js";
import AddAnnouncements from "./pages/Announcments/Add-Announcements.jsx";
import PayinVoice from "./pages/MyPayroll/pay-invoice.js";
import EditAnnouncements from "./pages/Announcments/Emp-Announcments.jsx";
import MyEditWorkReport from "./pages/MyWorkReport/my-edit-report.js";
import EditEmp from "./pages/AddEmp/edit-emp.js";
import EditHrTiming from "./pages/HRSchedule/edit-hr-timing.js";
import Announcement from "./pages/MyAnnouncement/Annoncement.jsx";
import PasswordReset from "./pages/PasswordReset.js";
import ForgotPassword from "./pages/ForgotPassword.js";
import MyDeptAnnouncement from "./pages/MyAnnouncement/my-dept-announcement.jsx";
import MonthlyAtd from "./pages/EmpAtd/current-month-atd.js";
import AddDeptAnnouncements from "./pages/DeptAnnouncements/Add-DeptAnnouncements.jsx";
import EditHR from "./pages/AddHR/edit-hr.js";
import UserAnnouncements from "./pages/Announcments/Emp-UserAnnouncments.jsx";
import AddUserAnnouncements from "./pages/Announcments/Add-userAnnouncements.jsx";
import EditUserAnnouncements from "./pages/Announcments/Edit-UserAnnouncements.jsx";
import EditDeptAnnouncements from "./pages/Announcments/Edit-DeptAnnouncement.js";
import ExEmployeeInformation from './pages/AddEmp/ex-emp-info.js';
import LeaveManagement from "./pages/MyLeave/LeaveManagement.js";
import DepartmentsTable from "./pages/Departments/Departments";
import AddDepartments from "./pages/Departments/Add-Departments";
import EditDepartments from "./pages/Departments/Edit-Departments";
import { ViewAbsDay } from './pages/EmpAtd/view-absents.js';
import { ViewAtdDay } from './pages/EmpAtd/view-atd-day.js';
import LeaveLayout from "./components/LeaveLayoutemp.jsx";
import LeaveBalance from "./pages/LeaveNew/LeaveBalance.jsx";
import AddLeave from "./pages/LeaveNew/addleave.js";
import PendingLeaveEmp from "./pages/LeaveNew/pending-Leave.js";
import LeaveDashboard from "./pages/ManagerLeaveSystem/LeaveManagement.js";
import { useState, useEffect } from "react";
import UnseenAnnouncementsDialog from "./components/UnseenAnnouncementsDialog";

// Protected Route Component
const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem('accessToken') && localStorage.getItem('refreshToken');
  return isAuthenticated ? element : <Navigate to="/" />;
};

// Prevent user from accessing sign-in page if already authenticated
const RedirectIfAuthenticated = ({ element }) => {
  const isAuthenticated = localStorage.getItem('accessToken') && localStorage.getItem('refreshToken');
  return !isAuthenticated ? element : <Navigate to="/dashboard" />;
};

// MainLayout Component with dialog logic
const MainLayout = () => {
  const [showUnseenDialog, setShowUnseenDialog] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const shouldShow = localStorage.getItem('shouldShowUnseenDialog');
    const lastLoginTime = localStorage.getItem('lastLoginTime');
    const lastDialogShown = localStorage.getItem('lastDialogShownTime');
    
    if (shouldShow === 'true') {
      if (!lastDialogShown || (lastLoginTime && parseInt(lastLoginTime) > parseInt(lastDialogShown))) {
        setShowUnseenDialog(true);
        localStorage.setItem('lastDialogShownTime', Date.now().toString());
        localStorage.removeItem('shouldShowUnseenDialog');
      }
    }
  }, []);

  // Modified navigation handler to handle both cases
  const handleNavigateToAnnouncements = (announcement = null) => {
    // Navigate to the announcements page
    if (announcement) {
      // If specific announcement is provided, pass it as state
      navigate('/emp-announcements', { state: { selectedAnnouncement: announcement } });
    } else {
      // If no specific announcement, just navigate to the page
      navigate('/emp-announcements');
    }
  };

  return (
    <>
      <SideBar>
        <div className="content-container">
          <Navbar />
          <Routes>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="handbook" element={<Handbook />} />
            <Route path="emp-announcements" element={<EmpAnnouncments />} />
            <Route path="dept-announcements" element={<DeptAnnouncements />} />
            <Route path="user-announcements" element={<UserAnnouncements />} />
            <Route path="add-announcements" element={<AddAnnouncements />} />
            <Route path="edit-announcement/:id" element={<EditAnnouncements />} />
            <Route path="add-user-announcements" element={<AddUserAnnouncements />} />
            <Route path="add-dept-announcements" element={<AddDeptAnnouncements />} />
            <Route path="rules" element={<Rules />} />
            <Route path="public-holidays" element={<PublicHolidays />} />
            <Route path="add-holiday" element={<AddHoliday />} />
            <Route path="edit-public-holidays/:id" element={<EditHoliday />} />
            <Route path="emp-info" element={<EmployeeInformation />} />
            <Route path="add-emp" element={<AddEmp />} />
            <Route path="edit-emp/:userId" element={<EditEmp />} />
            <Route path="hr-info" element={<HrInformation />} />
            <Route path="add-hr" element={<AddHR />} />
            <Route path="edit-hr/:userId" element={<EditHR />} />
            <Route path="emps-schedule" element={<EmpsSchedule />} />
            <Route path="emp-timing/:userId" element={<EmpTiming />} />
            <Route path="edit-timing/:userId" element={<EditTiming />} />
            <Route path="hr-schedule" element={<HrSchedule />} />
            <Route path="hr-timing/:userId" element={<HrTiming />} />
            <Route path="edit-hr-timing/:userId" element={<EditHrTiming />} />
            <Route path="hr-shift" element={<HrShift />} />
            <Route path="total-leave" element={<TotalLeave />} />
            <Route path="pending-leave" element={<PendingLeave />} />
            <Route path="approved-leave" element={<ApprovedLeave />} />
            <Route path="rejected-leave" element={<RejectedLeave />} />
            <Route path="leave-report" element={<LeaveReport />} />
            <Route path="emps-leave-reports" element={<EmpsLeaveReports />} />
            <Route path="leave" element={<Leave />} />
            <Route path="emps-performance" element={<Performance />} />
            <Route path="edit-atd/:attendanceId" element={<EditAtd />} />
            <Route path="add-atd" element={<AddAtd />} />
            <Route path="reports" element={<Reports />} />
            <Route path="current-atd" element={<CurrentAtd />} />
            <Route path="yesterday-atd" element={<YesterdayAttendance />} />
            <Route path="view-atd" element={<ViewAtd />} />
            <Route path="all-emps" element={<AllEmps />} />
            <Route path="add-absent" element={<AddAbsent />} />
            <Route path="today-reports" element={<TodayReport />} />
            <Route path="current-month-work-report" element={<MonthReport />} />
            <Route path="all-work-reports" element={<EmpsWorkReports />} />
            <Route path="team-chart" element={<EmployeeHierarchy />} />
            <Route path="my-payroll" element={<MyPayroll />} />
            <Route path="my-edit-report/:reportId" element={<MyEditWorkReport />} />
            <Route path="profile" element={<Profile />} />
            <Route path="pay-invoice" element={<PayinVoice />} />
            <Route path="my-schedule" element={<MySchedule />} />
            <Route path="my-salary" element={<Salary />} />
            <Route path="my-overtime-report" element={<OverTimeReport />} />
            <Route path="my-work-reports" element={<WorkReports />} />
            <Route path="account-settings" element={<Settings />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="add-report" element={<AddReport />} />
            <Route path="provident-fund" element={<ProvidentFund />} />
            <Route path="provident-fund-history" element={<ProvidentFundHistory />} />
            <Route path="provident-fund-req" element={<ProvidentFundReq />} />
            <Route path="time-history" element={<TimeHistory />} />
            <Route path="timings-history" element={<TimingsHistory />} />
            <Route path="announcement" element={<Announcement />} />
            <Route path="my-dept-announcements" element={<MyDeptAnnouncement />} />
            <Route path="current-month-atd/:userId" element={<MonthlyAtd />} />
            <Route path="edit-user-announcements/:id" element={<EditUserAnnouncements />} />
            <Route path="edit-dept-announcement/:id" element={<EditDeptAnnouncements />} />
            <Route path="ex-emp-info" element={<ExEmployeeInformation />} />
            <Route path="leave-management" element={<LeaveManagement />} />
            <Route path="departments" element={<DepartmentsTable />} />
            <Route path="add-departments" element={<AddDepartments />} />
            <Route path="edit-departments/:id" element={<EditDepartments />} />
            <Route path="view-absents" element={<ViewAbsDay />} />
            <Route path="view-atd-day" element={<ViewAtdDay />} />
            <Route path="add-leave" element={<LeaveLayout />} />
            <Route path="addleave" element={<AddLeave />} />
            <Route path="leave-balance" element={<LeaveBalance />} />
            <Route path="my-leaves-status" element={<PendingLeaveEmp />} />
            <Route path="leavemanager" element={<LeaveDashboard />} />
          </Routes>
        </div>
      </SideBar>
      
      <UnseenAnnouncementsDialog
        show={showUnseenDialog}
        onClose={() => setShowUnseenDialog(false)}
        onNavigateToAnnouncements={handleNavigateToAnnouncements}
      />
    </>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Signin route */}
        <Route path="/" element={<RedirectIfAuthenticated element={<Signin />} />} />
        <Route path="password-reset" element={<PasswordReset />} />
        <Route path="forgotpassword/:userId/:token" element={<ForgotPassword />} />
        
        {/* Dashboard and other routes with Sidebar */}
        <Route
          path="/*"
          element={
            <ProtectedRoute element={<MainLayout />} />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;